export default __webpack_public_path__ + "static/media/Damaso.45ca170c.png";